var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E5E1EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4048 13.5142H24.8892C26.9432 13.5142 28.6082 15.4343 28.6082 16.9906V26.0091C28.6082 27.9292 26.943 29.4856 24.8892 29.4856H11.4048C9.35073 29.4856 7.68579 27.5655 7.68579 26.0091V16.9906C7.68579 15.0705 9.35093 13.5142 11.4048 13.5142Z",
    fill: "#A47AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.016 15.7181L30.1903 17.3674V25.629L33.0133 27.2783C34.4834 28.1369 35.6877 27.5139 35.6877 25.8934V17.1026C35.6905 15.4769 34.4864 14.8591 33.016 15.7177L33.016 15.7181Z",
    fill: "#A47AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPurple);
export default __webpack_public_path__ + "static/media/CameraPurple.2134e2afea6591c2d6d257cfa2b8fd77.svg";
export { ForwardRef as ReactComponent };